import React, { useEffect, useState } from 'react'
import useWordle from '../hooks/useWordle'

// components
import Grid from './Grid'
import Keypad from './Keypad'
import Modal from './Modal'
import { useQuestionStore } from '../../../../store/useQuestionStore'
import Stack from '@mui/material/Stack';
import { QUESTION_STATE_SCENARIOS } from '../../../../constants/appConstants'
import { Box } from '@mui/material'

export default function Wordle({ solution }) {
  const { currentGuess, guesses, turn, isCorrect, usedKeys, handleKeyup, handleLetterClick } = useWordle(solution)
  const [showModal, setShowModal] = useState(false)
  const questionStore = useQuestionStore()

  const questionState = questionStore.questionState;
  const answerState = questionState ?? questionState[0]?.answerState
  const voteSubmitted = questionState ?? questionState[0]?.voteSubmitted
  console.log("Wordle questionStore.questionState voteSubmitted", voteSubmitted);

  const { NOT_STARTED, PARTIALLY_SOLVED: PARTIALLY_VALID } = QUESTION_STATE_SCENARIOS

  useEffect(() => {
    window.addEventListener('keyup', handleKeyup)

    if (isCorrect) {
      setTimeout(() => setShowModal(true), 2000)
      window.removeEventListener('keyup', handleKeyup)
    }
    if (turn > 5) {
      setTimeout(() => setShowModal(true), 2000)
      window.removeEventListener('keyup', handleKeyup)
    }

    return () => window.removeEventListener('keyup', handleKeyup)
  }, [handleKeyup, isCorrect, turn])

  return (
    <div>
      <Grid guesses={guesses} currentGuess={currentGuess} turn={turn} />
      {(voteSubmitted && [NOT_STARTED, PARTIALLY_VALID].includes(answerState)) && <>
        <Box alignContent={'center'} textAlign={"center"}>
          <Stack direction="row" spacing={2} alignContent={'center'} textAlign={"center"}>
            <p>Correct Answer: </p>
            <h2>HELLO</h2>
          </Stack>
          </Box>

      </>}
      <Keypad usedKeys={usedKeys} handleLetterClick={handleLetterClick} />

      {showModal && <Modal isCorrect={isCorrect} turn={turn} solution={solution} />}
    </div>
  )
}
